import React from 'react';
import {
  AutoVehicles,
  BookingTickets,
  BusinessManagement,
  CRM,
  Cryptocurrency,
  DesignGraphics,
  DeviceAutomation,
  Education,
  EmployeeManagement,
  FinanceBanking,
  Healthcare,
  MediaEntertainment,
  PaymentGateway,
  Productivity,
  Recruitment,
  Television,
  TrackingTool,
} from '../../../../assets/svg/index';

interface IndustryIcon {
  [key: string]: React.FC;
}

export const getIndustryIcons = (): IndustryIcon => ({
  'Auto & Vehicles': AutoVehicles,
  'Booking & Tickets': BookingTickets,
  'Business Management': BusinessManagement,
  CRM: CRM,
  Cryptocurrency: Cryptocurrency,
  'Design & Graphics': DesignGraphics,
  'Device Automation': DeviceAutomation,
  Education: Education,
  'Employee Management': EmployeeManagement,
  'Finance & Banking': FinanceBanking,
  Healthcare: Healthcare,
  'Media & Entertainment': MediaEntertainment,
  'Payment Gateway': PaymentGateway,
  Productivity: Productivity,
  Recruitment: Recruitment,
  Television: Television,
  'Tracking Tool': TrackingTool,
  default: Healthcare,
});
